import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

interface SignupPromptProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const SignupPrompt: React.FC<SignupPromptProps> = ({ open, onOpenChange }) => {
  const navigate = useNavigate();

  // Notify the demo system when the signup prompt opens
  useEffect(() => {
    if (open) {
      window.dispatchEvent(new CustomEvent('bigsplice:signup-prompt'));
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-3 mb-1">
            <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <UserPlus className="h-5 w-5 text-primary" />
            </div>
            <DialogTitle>Create a free account</DialogTitle>
          </div>
          <DialogDescription>
            Sign up to upload your own files, save flows, and access the full BigSplice platform.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => navigate('/login')}>
            Sign In
          </Button>
          <Button onClick={() => navigate('/register')}>
            Sign Up Free
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
